// extracted by mini-css-extract-plugin
module.exports = {"ipad_layout":"ipad_layout-I3qDeHtY","layout":"layout-2QlrJZv-","topAd0":"topAd0-1LS8nYje","bottomAd1":"bottomAd1-1d529209"};